import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 2H2V11H11V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H13V11H22V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 13H2V22H11V13Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.5 12.9999H16.5V16.5H13V18.5H16.5V22H18.5V18.5H22V16.5H18.5V12.9999Z"}}]};

const GridAddFilled = Vue.extend<IconProps>({
  name: 'GridAddFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'grid-add-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default GridAddFilled;
